import { useNavigate, useSearchParams } from "react-router-dom";
import classes from "./SubscriptionPage2.module.css";
import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa6";
import { v4 as uuidv4 } from "uuid";
import SmallLoader from "../../component/SmallLoader";
import { loginApi, SendOtpAPI } from "../../http/http";
import { setUserDetails } from "../../store/slices/userSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18n from "../../locales/i18n";
import { setLanguage } from "../../store/slices/languageSlice";

const SubscriptionPage2 = () => {
  const [msisdn, setMsisdn] = useState("");
  const [loading, setLoading] = useState(false);
  const [extRef, setExtRef] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedPack, setSelectedPack] = useState("Daily");
  const [packNo, setPackNo] = useState("50");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector(state => state?.persisted?.userSlice);

  const { selectedLanguage } = useSelector((state) => state.languageSlice);

  const { t } = useTranslation();

  useEffect(() => {
    if (selectedLanguage && i18n.language !== selectedLanguage) {
      i18n.changeLanguage(String(selectedLanguage));
    }
  }, [selectedLanguage, i18n]);

  useEffect(() => {
    if (userDetails?.token) navigate("/home");
  }, [userDetails]);

  useEffect(() => {
    if (searchParams.get("ext_ref")) {
      setExtRef(searchParams.get("ext_ref"));
    } else {
      setSearchParams({ ext_ref: uuidv4() });
    }
  }, [searchParams]);

  const handleFormSubmission = async (e) => {
    e.preventDefault();
    if (msisdn?.trim().length === 0) return;
    try {
      setLoading(true);
      // const response = await loginApi("1234");

      const response = await loginApi('1234');
      console.log(response, "response");
      // dispatch(setUserDetails(response?.data));
      // setLoading(false);
      // toast.success("Login Successfully!");
      // navigate("/home");

      dispatch(setUserDetails(response?.data?.result));
      setLoading(false);
      toast.success(t("21"));
      navigate("/home");

      // navigate("/otp", {
      //   state: {
      //     msisdn: msisdn,
      //     pack: selectedPack,
      //     extRef: extRef,
      //     packNo: packNo
      //   }
      // })

    } catch (error) {
      if (error?.response?.data?.status == 1) {
        // toast.error(t("94"));

        await loginApi(msisdn)
          .then((res) => {
            setLoading(false);
            dispatch(setUserDetails(res?.data?.result));
            navigate("/home");
            toast.success(t("21"));
          })
          .catch((err) => {
            setLoading(false);

            if (err?.response?.data?.error?.status == 1) {
              navigate("/low-balance");
            }
            else {
              toast.error(t("20"));
            }
          });
      }
      else {
        setLoading(false);

        toast.error(t("20"));
      }
    }
  };

  return (
    <div className={classes.page}>

      <select
        id="lang"
        name="lang"
        className={classes.dropdown}
        value={selectedLanguage}
        onChange={(event) => {
          dispatch(setLanguage(event.target.value));
        }}
      >
        <option value="0">English</option>
        <option value="1">French</option>
      </select>

      {/* ══ LEFT — Brand Hero ══ */}
      <div className={classes.leftPanel}>
        <div className={classes.arcCircle} />

        {/* Logo */}
        <div className={classes.logo}>
          {/* <span className={classes.logoIcon}>⚽</span>
          <span className={classes.logoWordmark}>
            <em>Football</em> Masters
          </span> */}

          <img src="/assets/images/logo.png" alt="football" className={classes.logo_img} />
        </div>

        {/* Hero copy */}
        <p className={classes.heroEyebrow}>{t("22")}</p>
        <h1 className={classes.heroTitle}>
          {t("23")}
          <span className={classes.accent}>{t("24")}</span>
        </h1>
        <p className={classes.heroSub}>
          {t("25")}
        </p>

        {/* Feature pills */}
        <div className={classes.pillsRow}>
          <span className={classes.pill}>{t("26")}</span>
          <span className={classes.pill}>{t("27")}</span>
          <span className={classes.pill}>{t("28")}</span>
        </div>


        {/* Stats */}
        {/* <div className={classes.statsRow}>
          <div className={classes.stat}>
            <span className={classes.statNum}>2M+</span>
            <span className={classes.statLabel}>Players</span>
          </div>
          <div className={classes.statDivider} />
          <div className={classes.stat}>
            <span className={classes.statNum}>₹50L</span>
            <span className={classes.statLabel}>Prizes Won</span>
          </div>
          <div className={classes.statDivider} />
          <div className={classes.stat}>
            <span className={classes.statNum}>500+</span>
            <span className={classes.statLabel}>Matches</span>
          </div>
        </div> */}
      </div>

      {/* ══ RIGHT — Form ══ */}
      <div className={classes.rightPanel}>
        <div className={classes.formContainer}>

          <h2 className={classes.formTitle}>
            {t("29")} <span>{t("30")}</span>
          </h2>
          <p className={classes.formSubtitle}>
            {t("31")}
          </p>

          {/* Tab toggle */}
          <div className={classes.tabToggle}>
            <button
              type="button"
              className={classes.tab}
              onClick={() => navigate(`/login?ext_ref=${extRef}`)}
            >
              {t("32")}
            </button>
            <button type="button" className={`${classes.tab} ${classes.activeTab}`}>
              {t("33")}
            </button>
          </div>

          <form onSubmit={handleFormSubmission}>
            {/* Phone */}
            <p className={classes.sectionLabel}>{t("34")}</p>
            <div className={classes.phoneRow}>
              <div className={classes.countryPill}>
                <img src="/assets/images/flag.png" alt="India" className={classes.flag} />
                <span className={classes.dialCode}>+233</span>
              </div>
              <input
                id="msisdn"
                name="msisdn"
                type="number"
                autoFocus
                onWheel={(e) => e.target.blur()}
                placeholder={t("35")}
                className={classes.phoneInput}
                onChange={(e) => setMsisdn(e.target.value)}
                value={msisdn}
              />
            </div>

            {/* Plans */}
            <div className={classes.plansSection}>
              <p className={classes.sectionLabel}>{t("36")}</p>
              <div className={classes.plansGrid}>

                {/* Daily */}
                <button
                  type="button"
                  className={`${classes.planCard} ${selectedPack === "Daily" ? classes.selDaily : ""}`}
                  onClick={() => {
                    setSelectedPack("Daily")
                    setPackNo("50")
                  }}
                >
                  <span className={classes.planEmoji}>⚡</span>
                  <span className={classes.planName}>{t("37")}</span>
                  <span className={classes.planPrice}>1 Cedi / {t("38")}</span>
                  <span className={classes.planDesc}>{t("39")}</span>
                  <div className={classes.radioRing}>
                    {selectedPack === "Daily" && <FaCheck className={classes.checkIcon} />}
                  </div>
                </button>

              </div>
            </div>

            {/* Terms */}
            <div className={classes.termsRow}>
              <input
                type="checkbox"
                id="terms"
                name="Terms & Conditions"
                value="Terms"
                className={classes.termsCheck}
                checked
                readOnly
              />
              <label htmlFor="terms" className={classes.termsText}>
                {t("44")}{" "}
                <span className={classes.termsLink}>{t("45")}</span>
              </label>
            </div>

            {/* CTA */}
            <button type="submit" disabled={loading} className={classes.ctaBtn}>
              {loading
                ? <SmallLoader style={{ border: "4px solid #0f0e0d" }} />
                : <>⚽ {t("46")}</>
              }
            </button>
          </form>

          {/* ── Copyright footer ── */}
          <div className={classes.copyrightFooter}>
            <div className={classes.copyrightDivider} />
            <div className={classes.copyrightInner}>
              <span className={classes.copyrightBadge}>
                <span className={classes.copyrightBadgeIcon}>⚽</span>
                Football Masters
              </span>
              <p className={classes.copyrightText}>
                © {new Date().getFullYear()} Rainboo Softmate Pvt Ltd
              </p>
              <p className={classes.copyrightSub}>All rights reserved</p>
            </div>
          </div>

          {/* Trust strip */}
          {/* <div className={classes.trustStrip}>
            <span className={classes.trustItem}>🔒 Secure Payment</span>
            <span className={classes.trustDot} />
            <span className={classes.trustItem}>✓ Cancel Anytime</span>
            <span className={classes.trustDot} />
            <span className={classes.trustItem}>💬 24/7 Support</span>
          </div> */}

        </div>
      </div>

    </div>
  );
};

export default SubscriptionPage2;